export const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  published: "Published",
  archived: "Archived",
  in_progress: "In progress",
  completed: "Completed",
  abandoned: "Abandoned",
};

// Status dot colours for the redesigned sim tables.
export type StatusTone = "green" | "amber" | "gray";

export const ATTEMPT_TONE: Record<string, StatusTone> = {
  completed: "green",
  in_progress: "amber",
  abandoned: "gray",
};

export const SCENARIO_TONE: Record<string, StatusTone> = {
  published: "green",
  draft: "amber",
  archived: "gray",
};

export function pct(value: number | null | undefined) {
  return value === null || value === undefined ? "—" : `${value.toFixed(value % 1 ? 1 : 0)}%`;
}

export function score(value: number | null, max: number) {
  return value === null ? "—" : `${value}/${max}`;
}

export const DOMAIN_LABELS: Record<string, string> = {
  history_taking: "History taking",
  examination: "Examination",
  diagnosis: "Diagnosis",
  management: "Management",
  counseling: "Counseling",
  follow_up: "Follow-up",
};

// Template sections, as named in the "Regenerate …" dialog.
export const SECTION_LABELS: Record<string, string> = {
  case_information: "case information",
  reference_sources: "reference sources",
  patient_profile: "patient profile",
  case_introduction: "case introduction",
  opening_statement: "opening statement",
  dialogue_steps: "branching dialogue",
  critical_decision_points: "critical decision points",
  performance_bands: "branching logic",
  feedback_rules: "feedback rules",
  key_learning_points: "key learning points",
  reflection_prompts: "reflection prompts",
};
